import axios from 'axios'
import { i18n } from '../../../plugins/i18n'

export const companiesStoreCompetitors = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
  },
  mutations: {
    prepareApi(state) {
      state.loading = true
    },
    readCompetitorsSuccess(state, payload) {
      state.data = payload
      state.loading = false
    },
    readCompetitorsFailure(state) {
      state.loading = false
    },
    deleteCompetitorSuccess(state, competitorId) {
      state.data.data = state.data.data.filter((value) => value.id != competitorId)
      state.loading = false
    },
    deleteCompetitorsFailure(state) {
      state.loading = false
    },
  },
  actions: {
    readCompetitors({ commit }, {company_uuid, store_uuid}) {
      commit('prepareApi')
      return axios
        .get('/api/companies/' + company_uuid + '/stores/' + store_uuid + '/competitors')
        .then(res => {
          commit('readCompetitorsSuccess', res.data)
        })
        .catch(err => {
          commit('readCompetitorsFailure')
          console.error(err)
        })
    },
    deleteCompetitor({ state, commit }, { company_uuid, store_uuid, competitor_id }) {
      if (state.loading) return

      commit('prepareApi')
      return axios
        .delete('/api/companies/' + company_uuid + '/stores/' + store_uuid + '/competitors/' + competitor_id)
        .then(() => {
          commit('deleteCompetitorSuccess', competitor_id)
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.deleted', { value: i18n.t('models.competitor.modelName') }) }, { root: true })
          return true
        })
        .catch(err => {
          console.error(err)
          commit('deleteCompetitorsFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          return false
        })
    }
  }
}
